import * as yup from "yup";

const validationSchema = yup.object().shape({
  name: yup.string().trim().required("Name is required"),
});

export { validationSchema };
